<template>
  <div class="search-filter-add">

    <input
        id="suggestId"
        type="hidden"
        name="suggestId"
    >

    <input
        id="suggestType"
        type="hidden"
        name="suggestType"
    >

    <!--  Start price  -->
    <div class="row">
      <div class="form-field form-field--stretch form-field--style-1 form-field--no-asterisk col">
        <div
            v-if="showTitle"
            class="filter-label"
        >
          <i class="fas fa-coins d-none d-sm-block"></i>
          <label class="col-form-label">{{ $t('messages_nl.form.label.rentalPrice') }}</label>
        </div>
        <div class="input-with-icon">
          <select
              id="price_from"
              v-model="filters['from']"
              class="form-control"
              name="price_from"
              @change="updatePrice('from')"
          >
            <option
                v-for="(price, index) in priceFrom"
                :key="index"
                :value="price.value"
            >
              {{ price.name }}
            </option>
          </select>
          <i class="fas fa-euro-sign"></i>
        </div>
      </div>
    </div>

    <!-- until price -->
    <div class="row">
      <div class="form-field form-field--stretch form-field--style-1 form-field--no-asterisk col">
        <div class="input-with-icon">
          <select
              id="price_till"
              v-model="filters['till']"
              class="form-control"
              name="price_till"
              @change="updatePrice('till')"
          >
            <option
                v-for="(price, index) in priceTill"
                :key="index"
                :value="price.value"
            >
              {{ price.name }}
            </option>
          </select>
          <i class="fas fa-euro-sign"></i>
        </div>
      </div>
    </div>

    <slot></slot>

    <div class="form-wrapper form-wrapper--no-asterisk form-wrapper--margin-2">

      <!-- checkbox options -->
      <template v-if="checkbox">
        <div
            v-for="(filter, index) in checkbox"
            :key="index"
            class="form-wrapper__item order-2"
        >
          <div
              v-if="showTitle"
              class="filter-label"
              data-toggle="collapse"
              :data-target="'#collapse-checkbox-' + filter.id"
          >
            <i :class="[filter.icon, 'fas', 'd-none', 'd-sm-block']"></i>
            <label class="col-form-label">{{ filter.name }}</label>
          </div>
          <div
              :id="'collapse-checkbox-' + filter.id"
              class="collapse show"
              data-toggle="collapse"
          >
            <div
                v-for="(option, index) in filter.options"
                :key="index"
                class="custom-control custom-checkbox"
            >
              <input
                  :id="filter.id + '_' + index"
                  v-model="filters[filter.id]"
                  class="custom-control-input"
                  type="checkbox"
                  :name="filter.id + '[]'"
                  :value="option.value"
                  @click="$emit('clicked')"
              >
              <label
                  :for="filter.id + '_' + index"
                  class="custom-control-label"
              >
                {{ option.name }}
              </label>
            </div>
          </div>
        </div>
      </template>

      <!--  radio options  -->
      <template v-if="radio">
        <div
            v-for="(filter, index) in radio"
            :key="index"
            class="form-wrapper__item"
            :class="index === 'rentalType' ? 'order-first' : 'order-3'"
        >
          <div
              v-if="showTitle"
              class="filter-label"
              data-toggle="collapse"
              :data-target="'#collapse-radio-' + filter.id"
          >
            <i :class="[filter.icon, 'fas', 'd-none', 'd-sm-block']"></i>
            <label class="col-form-label">
              {{ filter.name }}
            </label>
          </div>
          <div
              :id="'collapse-radio-' + filter.id"
              ref="radioContainer"
              class="collapse show"
              data-toggle="collapse"
          >
            <div
                v-for="(option, index) in filter.options"
                v-show="index < collapse.maxItems"
                :key="index"
                class="form-check"
            >
              <input
                  :id="filter.id + '_' + index"
                  v-model="filters[filter.id]"
                  class="form-check-input"
                  type="radio"
                  :name="filter.id"
                  :value="option.value"
                  @click="$emit('clicked')"
              >
              <label
                  :for="filter.id + '_' + index"
                  class="form-check-label"
              >
                {{ option.name }}
              </label>
            </div>
            <div
                v-if="undefined !== filter.options && filter.options.length > collapse.maxItems"
                class="show-options"
                @click="toggleShowMoreLess($event, filter.id)"
            >
              <span> {{ $t('messages_nl.search-form.showMore') }} </span>
            </div>
          </div>
        </div>
      </template>

    </div>

  </div>
</template>

<script>
import validatePrice from "../../../../../common/js/components/validatePrice";
export default {
  name: 'adivare-filter-add',
  props: {
    showTitle: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  emits: ['clicked', 'updateFilters', 'updateCounts'],
  data() {
    return {
      collapse: {
        maxItems: 5, // max items in options list when options are collapsed
        filters: {}, // leave it as it is
      },
      filters: {}, // leave it as it is.
      preventUpdate: false,
    }
  },
  computed: {
    radio() {
      return this.$store.state.availableFilters.radio;
    },
    checkbox() {
      return this.$store.state.availableFilters.checkbox;
    },
    priceFrom() {
      return this.$store.state.availableFilters.priceFrom;
    },
    priceTill() {
      return this.$store.state.availableFilters.priceTill;
    },
  },
  watch: {
    filters: {
      deep: true,
      immediate: false,
      handler(newVal) {
        if (false === this.preventUpdate && Object.keys(newVal).length !== 0) {
          this.$emit('updateFilters', newVal);
          this.$emit('updateCounts', newVal);
        }
        this.preventUpdate = false;
      },
    },
    'filters.till': {
      immediate: true,
      handler(newVal) {
        this.updateNewsletterPricesTill(newVal);
      },
    },
    'filters.from': {
      immediate: true,
      handler(newVal) {
        this.updateNewsletterPricesFrom(newVal);
      },
    },
    '$store.state.filters': {
      deep: true,
      immediate: true,
      handler() {
        this.preventUpdate = true;
        this.filters = this.initializeFilters();
      },
    }
  },
  methods: {
    updatePrice(minMax) {
      validatePrice(minMax, this.filters, this.priceFrom, this.priceTill);
      this.$emit('clicked');
    },
    initializeFilters() {
      let location = this.$store.state.filters.location;
      if ((location.distance ?? 0) > 0) {
        location = {
          ...location,
          streetSlug: null,
          neighborhoodSlug: null,
          districtSlug: null,
        };
      }

      return {
        ...this.$store.state.filters.properties,
        ...this.$store.state.filters.price,
        ...location,
        sorting: this.$store.state.filters.sorting,
        page: 1,
      };
    },
    updateNewsletterPricesFrom(newVal) {
      const newsletterInputs = document.querySelectorAll('select[name^="newsletter_"][name$="[minimumPrice]"]');
      newsletterInputs.forEach(newsletterInput => newsletterInput.value = newVal);
    },
    updateNewsletterPricesTill(newVal) {
      const newsletterInputs = document.querySelectorAll('select[name^="newsletter_"][name$="[maximumPrice]"]');
      newsletterInputs.forEach(newsletterInput => newsletterInput.value = newVal);
    },
    // toggle between showing more or less options in options list
    toggleShowMoreLess(event, filterId) {

      // current element node
      let currentTarget = event.currentTarget;

      // container element of current element
      let container = currentTarget.parentNode;

      // input elements within container
      let inputs = container.getElementsByTagName('input');

      // from collapsed to expanded
      if (
          'undefined' === typeof this.collapse.filters[filterId] ||
          false === this.collapse.filters[filterId]
      ) {
        this.collapse.filters[filterId] = true;
        currentTarget.innerHTML = '<span>' + this.$t('messages_nl.search-form.showLess') + '</span>';
        for (let i = this.collapse.maxItems; i < inputs.length; i++) {
          inputs[i].parentNode.style.display = 'block';
        }
        // from expanded tot collapsed
      } else {
        this.collapse.filters[filterId] = false;
        currentTarget.innerHTML = '<span>' + this.$t('messages_nl.search-form.showMore') + '</span>';
        for (let i = this.collapse.maxItems; i < inputs.length; i++) {
          if (inputs[i].checked) {

            // hide item with index is equal to maxItems
            inputs[this.collapse.maxItems - 1].parentNode.style.display = 'none';
            // move checked input to top of list
            container.prepend(inputs[i].parentNode);
          } else {
            // hide all non checked items that have a index higher then maxItems
            inputs[i].parentNode.style.display = 'none';
          }
        }
      }
    }
  }
}
</script>
